import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import React from "react";
import { t } from "utilities/localization-utils";
import StringUtils from "utilities/string-utils";

const CLASS_NAME = "c-manage-team-settings";
interface ManageTeamMemberListTableRowProps {
    fullName?: string;
    id?: string;
    emailAddress: string;
    lastActiveDate?: string;
    onRemove?: (emailAddress: string) => void;
    isRemoved?: boolean;
    onRestore?: (emailAddress: string) => void;
    isOwner?: boolean;
}
const ManageTeamMemberListTableRow = ({
    fullName,
    emailAddress,
    id,
    lastActiveDate,
    isRemoved,
    onRestore,
    onRemove,
    isOwner,
}: ManageTeamMemberListTableRowProps) => {
    const handleOnRemoveClick = () => {
        onRemove?.(emailAddress);
    };

    const handleOnRestoreClick = () => {
        onRestore?.(emailAddress);
    };

    const isCurrentMember = StringUtils.hasValue(id);

    return (
        <tr>
            <td
                className={`${CLASS_NAME}__table__name${isRemoved ? "__removed" : ""}`}>
                {fullName}
            </td>
            <td
                className={`${CLASS_NAME}__table__email${isRemoved ? "__removed" : ""}`}>
                {emailAddress}
            </td>
            {isCurrentMember && !isRemoved ? (
                <>
                    <td className={`${CLASS_NAME}__table__date`}>
                        {lastActiveDate}
                    </td>
                    <td className={`${CLASS_NAME}__trash-can`}>
                        {!isOwner && !isRemoved && (
                            <Button
                                onClick={handleOnRemoveClick}
                                style={ButtonStyles.Tertiary}
                                size={ButtonSizes.XSmall}>
                                <Icon
                                    type={Icons.Trashcan}
                                    size={IconSizes.Large}
                                />
                            </Button>
                        )}
                    </td>
                </>
            ) : (
                <td
                    className={`${CLASS_NAME}__table__action__button`}
                    colSpan={2}>
                    {!isOwner && (
                        <>
                            {isRemoved ? (
                                <Button
                                    onClick={handleOnRestoreClick}
                                    size={ButtonSizes.Small}
                                    style={ButtonStyles.Destructive}>
                                    {t("undoDelete")}
                                </Button>
                            ) : (
                                <Button
                                    onClick={handleOnRemoveClick}
                                    size={ButtonSizes.Small}
                                    style={ButtonStyles.Destructive}>
                                    {isCurrentMember
                                        ? t("removeFromTeam")
                                        : t("cancelInvite")}
                                </Button>
                            )}
                        </>
                    )}
                </td>
            )}
        </tr>
    );
};

export default ManageTeamMemberListTableRow;
